import { Component } from "react";
import DataLoader from "./../../../../../DataLoader/DataLoader";
import TalaeraRoutes from "./../../../../../routes/TalaeraRoutes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { fetchCompletedSessions } from "./../../../../../../services/sessions";

const RECENT_SESSIONS_SIZE = 3;

export default class RecentSessionsSection extends Component {
  render() {
    return (
      <DataLoader
        fetchData={fetchCompletedSessions}
        fetchArgs={{ page: 1, size: RECENT_SESSIONS_SIZE }}
      >
        <RecentSessionsSectionInner {...this.props} />
      </DataLoader>
    );
  }
}

class RecentSessionsSectionInner extends Component {
  render() {
    return (
      <SidePanelSection
        sectionTitle="Recent Lessons"
        list={this.props.data.list}
        location={this.props.location}
        tagName={RecentSessionListItem}
      />
    );
  }
}

class RecentSessionListItem extends Component {
  render() {
    const path = TalaeraRoutes.buildHomeworkFilteredBySessionPath(this.props.item.id);
    const isActive = TalaeraRoutes.isHomeworkFilteredBySessionPath(
      this.props.location,
      this.props.item.id,
      true
    );
    return (
      <li className={isActive ? "active" : ""}>
        <Link
          className="btn"
          to={{
            pathname: path.substring(0, path.indexOf("?")),
            search: path.substring(path.indexOf("?"), path.length),
            state: { session_name: this.props.item.name },
          }}
        >
          {this.props.item.name ? this.props.item.name : "Unnamed"}
        </Link>
      </li>
    );
  }
}
